import { appConfig } from './customization';

const utilityURL = `${process.env.REACT_APP_ASSETS_BASE_URL}${appConfig.assets}`;
const commonsURL = `${process.env.REACT_APP_ASSETS_BASE_URL}commons`;
const topbarCustomIcons = appConfig.topbarCustomIcons ? utilityURL : commonsURL;

const Images = {
  authFormWrapper: `${utilityURL}/img_auth_avatar.png`,
  authBackground: `${utilityURL}/img_auth_background.png`,
  errorCactus: `${utilityURL}/img_placeholder_cuenta_cactus.png`,
  errorNoElements: `${utilityURL}/img_placeholder_sin_resultados.png`,
  errorTimer: `${utilityURL}/img_placeholder_timer.png`,
  withoutAccountsBackground: `${utilityURL}/withoutAccountsBackground.png`,
  withoutAccountsAvatar: `${utilityURL}/withoutAccountsAvatar.png`,
  topbarLogo: `${utilityURL}/topbarLogo.png`,
  topbarPoints: `${commonsURL}/topbarPoints.png`,
  topbarPointsHover: `${commonsURL}/topbarPointsHover.png`,
  topbarLogout: `${topbarCustomIcons}/topbarLogout.png`,
  topbarLogoutHover: `${topbarCustomIcons}/topbarLogoutHover.png`,
  topbarAlertOff: `${topbarCustomIcons}/topbarAlertOff.png`,
  topbarAlertOffHover: `${topbarCustomIcons}/topbarAlertOffHover.png`,
  topbarSettings: `${topbarCustomIcons}/topbarSettings.png`,
  topbarSettingsHover: `${topbarCustomIcons}/topbarSettingsHover.png`,
  listArrowUp: `${commonsURL}/ic_list_arrow_up.png`,
  listArrowDown: `${commonsURL}/ic_list_arrow_down.png`,
  energyAdvisorWheelButton01: `${commonsURL}/energyAdvisorWheelButton01.png`,
  energyAdvisorWheelButton02: `${commonsURL}/energyAdvisorWheelButton02.png`,
  energyAdvisorWheelButton03: `${commonsURL}/energyAdvisorWheelButton03.png`,
  energyAdvisorWheelButton04: `${commonsURL}/energyAdvisorWheelButton04.png`,
  energyAdvisorWheelButton05: `${commonsURL}/energyAdvisorWheelButton05.png`,
  energyAdvisorWheelButton06: `${commonsURL}/energyAdvisorWheelButton06.png`,
  energyAdvisorWheelButton01Hover: `${commonsURL}/energyAdvisorWheelButton01Hover.png`,
  energyAdvisorWheelButton02Hover: `${commonsURL}/energyAdvisorWheelButton02Hover.png`,
  energyAdvisorWheelButton03Hover: `${commonsURL}/energyAdvisorWheelButton03Hover.png`,
  energyAdvisorWheelButton04Hover: `${commonsURL}/energyAdvisorWheelButton04Hover.png`,
  energyAdvisorWheelButton05Hover: `${commonsURL}/energyAdvisorWheelButton05Hover.png`,
  energyAdvisorWheelButton06Hover: `${commonsURL}/energyAdvisorWheelButton06Hover.png`,
  energyAdvisorAvatar: `${utilityURL}/energyAdvisorAvatar.png`,
  energyAdvisorMobileAvatar: `${utilityURL}/energyAdvisorMobileAvatar.png`,
  energyAdvisorBackground: `${utilityURL}/energyAdvisorBackground.png`,
  pointsSlide1: `${commonsURL}/pointsSlide1.png`,
  pointsSlide2: `${commonsURL}/pointsSlide2.png`,
  pointsSlide3: `${commonsURL}/pointsSlide3.png`,
  pointsTrophy: `${commonsURL}/pointsTrophy.png`,
  complaintsContact1: `${utilityURL}/complaintsContact1.png`,
  complaintsContact2: `${utilityURL}/complaintsContact2.png`,
  complaintsContact3: `${utilityURL}/complaintsContact3.png`,
  paymentMastercard: `${commonsURL}/paymentMastercard.png`,
  paymentNativa: `${commonsURL}/paymentNativa.png`,
  paymentVisa: `${commonsURL}/paymentVisa.png`,
  paymentVisaBanelco: `${commonsURL}/paymentVisaBanelco.png`,
  downloadBill: `${utilityURL}/ic_bill_download.png`,
  downloadBillDisabled: `${utilityURL}/ic_bill_download_disabled.png`,
  icDeleteButton: `${commonsURL}/ic_delete_button.png`,
  sidebarAccountStatus: `${utilityURL}/sidebarAccountStatus.png`,
  sidebarAdvisor: `${utilityURL}/sidebarAdvisor.png`,
  sidebarArrowDown: `${utilityURL}/sidebarArrowDown.png`,
  sidebarArrowUp: `${utilityURL}/sidebarArrowUp.png`,
  sidebarBalanceQuery: `${utilityURL}/sidebarBalanceQuery.png`,
  sidebarBills: `${utilityURL}/sidebarBills.png`,
  sidebarChatbot: `${utilityURL}/sidebarChatbot.png`,
  sidebarComplaints: `${utilityURL}/sidebarComplaints.png`,
  sidebarCustomerSupport: `${utilityURL}/sidebarCustomerSupport.png`,
  sidebarEnergySimulator: `${utilityURL}/sidebarEnergySimulator.png`,
  sidebarHamburger: `${utilityURL}/sidebarHamburger.png`,
  sidebarLastBillInfo: `${utilityURL}/sidebarLastBillInfo.png`,
  sidebarPoints: `${utilityURL}/sidebarPoints.png`,
  sidebarSettings: `${utilityURL}/sidebarSettings.png`,
  sidebarSidemenuClose: `${utilityURL}/sidebarSidemenuClose.png`,
  sidebarSocialRate: `${utilityURL}/sidebarSocialRate.png`,
  sidebarTechnicalService: `${utilityURL}/sidebarTechnicalService.png`,
  publicHomeBackground: `${utilityURL}/publicHomeBackground.jpg`,
  publicChangeDueDateBackground: `${utilityURL}/publicChangeDueDateBackground.png`,
  linkedin: `${utilityURL}/linkedinLogo.svg`,
  facebook: `${utilityURL}/facebookLogo.svg`,
  twitter: `${utilityURL}/twitterLogo.svg`,
  bannerSignup: `${utilityURL}/bannerSignup.jpg`,
  appDownloaderAppstore: `${commonsURL}/appDownloaderAppstore.png`,
  appDownloaderGoogleplay: `${commonsURL}/appDownloaderGoogleplay.png`,
  appDownloaderPhone: `${utilityURL}/appDownloaderPhone.png`
};

export default Images;
